import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { selectedMetricsSelector, liveModeSelector } from '@store/metricLens/base/selectors';
import { LIVE_EXCLUDE_METRICS } from '@utils/metricLens/mapping';
import { notification } from 'antd';
import Tabs from '@components/common/Dashboard/DashboardTabs/Tabs';
import KebabDropDown from './KebabDropdown';
// import Tabs from './Tabs';
import { TopPanelWrapper, SummaryWrapper } from './styled';
import AllFilters from './AllFilters';
import TimeLive from './TimeLive';
import SampledDataWarning from '@components/common/SampledDataWarning';
import { getMetricDisplayName } from '@src/utils/metrics';

interface IProps {
  pageType: number;
  history: any;
  match: any;
}

// eslint-disable-next-line react/display-name
export default (props: IProps) => {
  const { history, pageType, match } = props;
  const currentShareId = get(match, 'params.id', 'metriclens');
  const selectedMetrics = useSelector(selectedMetricsSelector);
  const liveMode = useSelector(liveModeSelector);

  const getMetricDetails = (metrics: string[]) => {
    const metricNames: string[] = [];
    metrics.forEach((metricKey: string) => {
      const displayName = getMetricDisplayName({ metricKey });
      metricNames.push(displayName);
    });
    return metricNames;
  };

  useEffect(() => {
    if (liveMode) {
      const excludeList = LIVE_EXCLUDE_METRICS;
      const presentExclude = excludeList.filter((exclude) => {
        if (selectedMetrics.includes(exclude)) {
          return exclude;
        }
      });
      const excludeMetricNames = getMetricDetails(presentExclude);
      if (presentExclude.length > 0) {
        notification.open({
          message: 'Note',
          description: `Currently we do not support ${excludeMetricNames.join(', ')} for Live date picker option. Hence, we have removed those metrics from the selection.`,
          placement: 'bottomRight',
          duration: 10,
        });
      }
    }
  }, [liveMode, selectedMetrics]);

  return (
    <TopPanelWrapper>
      <Tabs currentShareId={currentShareId} history={history} pageType={pageType} />
      <AllFilters />
      <SummaryWrapper>
        <SampledDataWarning />
        {liveMode ? <TimeLive /> : null}
        <KebabDropDown currentShareId={currentShareId} pageType={pageType} />
      </SummaryWrapper>
    </TopPanelWrapper>
  );
};
